export const FB_SHARE_BASE_URL =
  'https://www.facebook.com/sharer/sharer.php?quote='
export const TWITTER_SHARE_BASE_URL = 'https://twitter.com/intent/tweet?text='
